import { AvailableRegions, MfDate, Period } from '../model';

const defaultLocale = 'en-GB';
const defaultFormatOptions: Intl.DateTimeFormatOptions = {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
};

// #FIXME: move this global state somewhere else. It doesn't belong to lib/utils
let locale = defaultLocale;

export function setDateFormatLocale(l: string) {
  locale = l;
}

export function getDateFormatLocale() {
  return locale;
}

export function guessDateFormatLocaleForRegion(region: AvailableRegions | undefined) {
  switch (region) {
    case AvailableRegions.EU:
      return 'de';
    case AvailableRegions.US_EAST:
      return 'en-US';
    case AvailableRegions.BR:
      return 'en-US';
    case AvailableRegions.AU:
      return 'en-AU';
    case AvailableRegions.JP:
      return 'en-GB';
    case AvailableRegions.UK:
      return 'en-GB';
    default:
      return defaultLocale;
  }
}

export function today(): Date {
  const date = new Date();
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

export function isToday(date: Date): boolean {
  date.setUTCHours(0, 0, 0, 0);
  return date.getTime() === today().getTime();
}

export function format(
  date: MfDate | Date | string,
  keepTime?: boolean,
  overrideLocale = locale,
): string {
  if (date instanceof MfDate) {
    return formatMfDateInstance(date, keepTime, overrideLocale);
  }

  if (date instanceof Date) {
    return formatDateInstance(date, keepTime, overrideLocale);
  }

  return formatDateString(date, keepTime, overrideLocale);
}

function formatMfDateInstance(date: MfDate, keepTime?: boolean, overrideLocale = locale): string {
  const native = date.toDate();

  if (keepTime) {
    const dateTimeFormat = new Intl.DateTimeFormat(overrideLocale, {
      dateStyle: 'short',
      timeStyle: 'short',
    });

    return dateTimeFormat.format(native);
  } else {
    const dateTimeFormat = new Intl.DateTimeFormat(overrideLocale, {
      ...defaultFormatOptions,
      timeZone: 'UTC', // Needed to keep the date timezone-agnostic
    });

    return dateTimeFormat.format(native);
  }
}

function formatDateInstance(date: Date, keepTime?: boolean, overrideLocale = locale): string {
  let dateTimeFormat;
  if (keepTime) {
    dateTimeFormat = new Intl.DateTimeFormat(overrideLocale, {
      dateStyle: 'short',
      timeStyle: 'short',
    });

    return dateTimeFormat.format(date);
  } else {
    dateTimeFormat = new Intl.DateTimeFormat(overrideLocale, {
      ...defaultFormatOptions,
      timeZone: 'UTC', // Needed to keep the date timezone-agnostic
    });

    return dateTimeFormat.format(MfDate.fromDate(date).toDate());
  }
}

function formatDateString(date: string, keepTime?: boolean, overrideLocale = locale): string {
  try {
    return format(new Date(date), keepTime, overrideLocale);
  } catch (e) {
    console.error(e);
  }

  return date;
}
